/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Input_Position_X_Dialog_TitleInputs */



/**
* | output |
* | --- |
* | "Set X Position" |
*
* @param {Input_Position_X_Dialog_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const input_position_x_dialog_title = /** @type {((inputs?: Input_Position_X_Dialog_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Input_Position_X_Dialog_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Définir la Position X")
	if (locale === "de") return /** @type {LocalizedString} */ ("X-Position festlegen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Imposta la posizione X")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Установить позицию X")
	if (locale === "es") return /** @type {LocalizedString} */ ("Establecer posición X")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("设置 X 位置")
	if (locale === "ja") return /** @type {LocalizedString} */ ("X位置の設定")
	if (locale === "hi") return /** @type {LocalizedString} */ ("X स्थिति निर्धारित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Defina a posição X")
	return /** @type {LocalizedString} */ ("Set X Position")
});